import type { Category } from '@/types'

/** Resolve a category accent (configured color or stable hash fallback). */
export function categoryColor(cat: Category | undefined, fallback: string): string {
  const raw = cat?.color?.trim()
  if (raw) {
    if (/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(raw)) return raw
    if (/^[0-9A-Fa-f]{6}$/.test(raw)) return `#${raw}`
    if (/^[0-9A-Fa-f]{3}$/.test(raw)) {
      const [a, b, c] = raw.split('')
      return `#${a}${a}${b}${b}${c}${c}`
    }
  }
  let h = 0
  const s = (cat?.name ?? fallback) || 'x'
  for (let i = 0; i < s.length; i++) h = (h + s.charCodeAt(i) * 17) % 360
  return `hsl(${h} 45% 42%)`
}

/** Soft card tint from a category accent (hex or hsl). */
export function categorySurfaceStyle(accent: string): { background: string } {
  return {
    background: `linear-gradient(135deg, color-mix(in srgb, ${accent} 30%, var(--card)) 0%, var(--card) 58%)`,
  }
}
